import { SetRoutes } from 'components';
import routes from './routes';

const UsersPremisionsPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default UsersPremisionsPage;
